import { Protocol } from './_types';

export const LIB_PROTOCOL_BLUEBERRY_HARVEST_SCREEN_EVAL: Protocol = {
    id: "blueberry_harvest_screen_eval",
    title: "Advanced Blueberry Harvest Evaluation",
    description: "Harvest evaluation is performed to characterise new cultivars and selections on the base of their fruit traits. Visual and sensory fruit evaluation are applied to describe bunch and berry quality and keeping ability after storage over a specified storage period. Characteristics such as appearance, defects and disorders and eating quality are evaluated in detail.",
    sampleType: "harvest",

    chars: [
       
        "blueberry_defects",
        "blueberry_perc_shrivel",
        "blueberry_perc_collapse", 
        "blueberry_perc_decay",   
        "blueberry_perc_immature",  

        "blueberry_ripe_stage",
        "blueberry_firm",
        "blueberry_firm_homog",
        "blueberry_mature_rate",

        "blueberry_over_color",
        "blueberry_ground_color",
        "blueberry_skin_bloom",
        "blueberry_flesh_color",
        "blueberry_pip_cavity_colour",
        "blueberry_pip_cavity_size",
        "blueberry_over_colour_area",
        "blueberry_over_pattern",
      
        "blueberry_shape_type",
        "blueberry_symmetry",
        "blueberry_shape_consistent",
        "blueberry_pendicul_depth",
        "blueberry_pendicul_width",
        "blueberry_calyx_open",
        "blueberry_calyx_depth",
        "blueberry_calyx_width",
        "blueberry_pendicul_tear",
        "blueberry_suture",
        "blueberry_sepal_remnant",

        "blueberry_abrasion",
        "blueberry_bruised",
        "blueberry_blemish",
        "blueberry_collaps",
        "blueberry_lenticel",
        "blueberry_wounds",

        "blueberry_taste_sugar",
        "blueberry_taste_acid",
        "blueberry_taste_balance",
        "blueberry_taste_aroma",
        "blueberry_taste_burst",
        "blueberry_taste_juice",
        "blueberry_taste_skin_thicc",
        "blueberry_taste_skin_tough",
        "blueberry_taste_firmness",
        "blueberry_taste_crisp",
        "blueberry_taste_crunch",
        "blueberry_taste_grain",

        "blueberry_perc_decay_bot",
        "blueberry_perc_decay_stb",
        "blueberry_perc_decay_pen",
        "blueberry_perc_decay_rhi",
        "blueberry_perc_decay_asp",
        "blueberry_perc_decay_alt",
        "blueberry_perc_decay_cyl",
        "blueberry_perc_decay_exo",
        "blueberry_perc_decay_phi",
        "blueberry_perc_decay_phy",

        "blueberry_rot_symptom",
        "blueberry_extdisorder",
        "blueberry_shrivel_degree",

        "blueberry_perc_bc_lateral",
        "blueberry_perc_bc_ring",
        "blueberry_perc_bc_stylar",

        "blueberry_woolli_symptom",
        "blueberry_sponge_symptom",
        "blueberry_intbreak_symptom",


        "frut_overall_keepqual",
        "frut_overall_appear",
        "frut_overall_color",
        "frut_overall_texture",
        "frut_overall_taste",
        "frut_overall_eatqual",
        "frut_overall_interest",
    ],

    measures: [
        "berry_len",
        "berry_dia",
        "berry_wei",
        "berry_tss",
        "berry_firmness",
        "berry_acid",
        

    ],

    indexes: [
        "indx_frut_overall"
    ],
};